import React, { Component } from 'react';

import './SectionHeader.scss';

class SectionHeader extends Component {
  render() {
    return (
      <>
        <div
          className={`ontario-row ontario-padding-top-16-!  ontario-padding-bottom-16-! ontario-margin-top-16-! ontario-margin-bottom-16-! ${
            this.props.isSummary ? '' : 'cviz-section-header'
          }`}
        >
          <div className="ontario-columns ontario-small-12 ontario-medium-12">
            <h2 id={this.props.id}>
              {this.props.title[this.props.lang]}
            </h2>
          </div>
          {/* <div className="ontario-columns ontario-small-12 ontario-medium-6">
            {this.props.lastUpdated}
          </div> */}
        </div>
        {this.props.children}
      </>
    );
  }
}
export default SectionHeader;
